var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    viewBox: "0 0 28 28",
    id: "sprite-mini-information",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h28v28H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm.808 7.666h-2.334c-.2 0-.333.133-.333.333v1.334c0 .2.133.333.333.333h.667v2.667h-1c-.2 0-.333.133-.333.333v1.333c0 .2.133.334.333.334h4c.2 0 .333-.133.333-.334v-1.333c0-.2-.133-.333-.333-.333h-1v-4.334c0-.2-.133-.333-.333-.333zM14.14 8.5c-.688 0-1.25.563-1.25 1.25 0 .688.563 1.25 1.25 1.25.688 0 1.25-.563 1.25-1.25 0-.688-.563-1.25-1.25-1.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoAlt);
export default __webpack_public_path__ + "static/media/info-alt.81613b85fe7c54d5a9b21230d9c7f0d5.svg";
export { ForwardRef as ReactComponent };